//We are settings an initial state here for clarity, probably is not needed

import OneSignal from "react-onesignal"

const Settings = {
  App: "ShearlyBI",
  Name: "ShearlyBI",

  baseURl: "./",
  //    BasePathForAPI: "https://app.pleelo.com/api/",//
  //BasePathForAPI: "https://vo.shearly.com/api/",//local on shearly
  BasePathForAPI: "https://api.bi.shearly.com/api/",
  BasePath: "https://api.bi.shearly.com/",
  GoogleMapsKey: "AIzaSyA5c0WhOqMatPEDmy2RGIBfvhSR9GFOr5k",

  SignalURL: "https://signal2.shearly.com/communicationHub",
  OneSignalAppId: "a46b5373-ac0b-4dd0-b92a-fc093cac876e",
  Roles: {
    Admin: "admin",
    User: "user",
  },
}

export default Settings
